import throttle from 'lodash/throttle';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconSearch from '@spothero/icons/search';
import AutoSuggestInput from '@spothero/ui/auto-suggest-input';
import TextInputPropTypes from '@spothero/ui/text-input-prop-types';
import APIUtils from '@spothero/utils/api';
import withConfig from 'config/withConfig';

class SearchInputMB extends Component {
    static propTypes = {
        ...TextInputPropTypes,
        /** Function to execute when a suggestion is selected. */
        onSuggestionSelect: PropTypes.func.isRequired,
        /** Optional function to execute when input field is cleared. */
        onClear: PropTypes.func,
        /** Used to limit the suggestion results by country. */
        country: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string),
        ]),
        /** Used to limit the suggestion results by certain google place types. */
        types: PropTypes.array,
        /** Used to limit the suggestion results by lat/long bounds. */
        bounds: PropTypes.object,
        mapboxToken: PropTypes.string.isRequired,
    };
    static defaultProps = {
        placeholder: 'Search Address or Venue',
        country: 'us',
        icon: <IconSearch />,
    };

    constructor(props) {
        super(props);

        this._suggestionFetch = throttle(this._searchForPlace, 500);

        this.state = {
            suggestions: [],
        };
    }

    _onChange = evt => {
        const {onChange} = this.props;
        const value = evt.target.value;

        if (!value || value.length < 3) {
            this.setState({
                suggestions: [],
            });
        } else {
            this._suggestionFetch(value);
        }

        if (onChange) {
            onChange(evt);
        }
    };

    _onSuggestionSelect = suggestion => {
        const {onSuggestionSelect} = this.props;

        onSuggestionSelect(suggestion);
    };

    _searchForPlace = place => {
        const {mapboxToken} = this.props;
        const mapboxPlaces =
            'https://api.mapbox.com/geocoding/v5/mapbox.places';
        const params = {
            // eslint-disable-next-line camelcase
            access_token: mapboxToken,
            limit: 10,
            country: ['us', 'ca'],
            proximity: 'geoip-f033fe71-6733-4484-8445-6f6744bd0337',
        };

        const setSuggestions = ({data: {features}}) => {
            this.setState({
                suggestions: features.map(feature => {
                    return {
                        label: feature.place_name,
                        description: feature.place_name,
                        id: feature.id,
                        latitude: feature.center[1],
                        longitude: feature.center[0],
                    };
                }),
            });
        };

        APIUtils.get(`${mapboxPlaces}/${place}.json`, params).then(
            setSuggestions
        );
    };

    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */
    get node() {
        return this._autosuggest.node;
    }

    render() {
        const {
            className,
            types,
            country,
            onClear,
            ...textInputProps
        } = this.props;
        const {suggestions} = this.state;
        const classes = classNames('SearchInputMB', className);

        return (
            <div className={classes}>
                <AutoSuggestInput
                    ref={node => {
                        this._autosuggest = node;
                    }}
                    {...textInputProps}
                    onChange={this._onChange}
                    suggestions={suggestions}
                    types={types}
                    country={country}
                    onClear={onClear}
                    onSuggestionSelect={this._onSuggestionSelect}
                    autoActivateFirstSuggest
                />
            </div>
        );
    }
}

export default withConfig(['mapboxToken'])(SearchInputMB);
